import { useQuery } from "@tanstack/react-query";
import { getBlogTags } from "../../api/apiBlogTags";
import i18next from "i18next";

/**
 * Hook لجلب قائمة وسوم المدونة المفلترة
 * @param {Object} params - Query parameters (page, per_page, search, trashed)
 */
export function useGetBlogTags(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["blog-tags", params, i18next.language],
        queryFn: () => getBlogTags(params),
        retry: false,
    });

    const tags = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, tags, meta, refetch };
}
